<template>
  <div class="Flavour Result" :class="classes">
    <div class="Flavour__background"></div>
    <Page>
      <div v-if="theme && params && scores" class="Flavour__content">
        <transition name="u-fade-in">
          <img
            v-if="show.logo"
            class="Flavour__logo"
            alt="The Glenlivet Spectra Flavour"
            :src="require(`../assets/logo-circle-${theme}.svg`)"
          />
        </transition>
        <div class="Flavour__radarChart">
          <radar-chart
            v-if="show.radarChart && dataReady"
            @animationFinished="showCta"
            :theme="this.theme"
            :flavours="flavours[theme]"
            :scores="scores"
            :active-labels="params"
          />
        </div>
        <transition name="u-fade-in">
          <div v-if="show.cta" class="Result__nav">
            <ShareSocialMedia
              copy="Share your score"
              :end="false"
            ></ShareSocialMedia>
            <base-button :theme="theme" @click="onNext" wide>Next</base-button>
          </div>
        </transition>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from '../components/Page'
import BaseButton from '../components/BaseButton'
import RadarChart from '../components/RadarChart'
import ShareSocialMedia from '../components/ShareSocialMedia'
import { flavourMixin } from '../mixins/flavourMixin'
import { audioMixin } from '../mixins/audioMixin'

export default {
  components: { RadarChart, BaseButton, Page, ShareSocialMedia },
  mixins: [flavourMixin, audioMixin],
  data() {
    return {
      scores: [],
      params: [],
      show: {
        logo: false,
        cta: false,
        radarChart: false
      },
      transitionDuration: 0,
      transitionDelay: 100
    }
  },
  mounted() {
    this.updateActiveStates()
    this.params = this.flavoursParamToArray()
    this.scores = this.flavourScoresParamToArray()
    this.startAnimation()
  },
  methods: {
    startAnimation() {
      setTimeout(() => {
        this.show.logo = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.radarChart = true
      }, (this.transitionDuration += this.transitionDelay))
    },
    flavourScoresParamToArray() {
      // Grabs the flavour scores from the URL so we can use in the radar chart
      return this.$route.query.flavour_scores.split(',')
    },
    showCta() {
      setTimeout(() => {
        this.show.cta = true
      }, 500)
    },
    async onNext() {
      // Go back to Index if user completed journey
      let savedState = JSON.parse(sessionStorage.getItem('glenlivet_state'))
      let completed = {
        ...savedState
      }
      completed[this.theme] = true
      sessionStorage.setItem('glenlivet_state', JSON.stringify(completed))

      savedState = JSON.parse(sessionStorage.getItem('glenlivet_state'))

      // If all sections are complete go to end page
      if (savedState.orchard && savedState.smoke && savedState.chard) {
        this.playSound(`end`)
        return this.$router.push({ path: '/end' })
      }
      this.playSound(`bottle-selection`)
      this.$router.push({ path: '/bottle-selection' })
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables.scss';
@import '../scss/mixins.scss';
@import '../scss/transitions.scss';
@import '../scss/flavour.scss';
.Result {
  &__nav {
    display: flex;
    width: calc(100% - 40px);
    justify-content: space-between;
    margin-top: -30px;
  }
  .Flavour__content {
    justify-content: normal;
  }
}

// Tablet styles
@include md {
  .Result {
    .Flavour__content {
      justify-content: normal;
    }
    .Flavour__radarChart {
      margin-top: 100px;
    }
  }
}
</style>
